import httpConfig from '../httpConfig.js'

console.log(2)
// console.log(http)
export default {
  refreshVerificationCode () {
    var random = httpConfig.accountSecurityVerify + '?a=' + Math.random()
    return random
  }
}
